import React, { useState } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import DataTable from "../DataTable/DataTable";
import { IoClose } from "react-icons/io5";

const AmendmentDetail = ({ open, setOpen, data, invoiceNo }) => {
  // Function to open the modal
  const handleOpen = () => setOpen(true);

  // Function to close the modal
  const handleClose = () => setOpen(false);

  const columns = [
    { field: "doc_id", headerName: "Document ID", width: 150 },
    { field: "charge_type", headerName: "Charge Type", width: 150 },
    { field: "country", headerName: "Country", width: 150 },
    {
      field: "rate",
      headerName: "Rate",
      width: 150,
    },
    {
      field: "service_description",
      headerName: "Service Description",
      width: 200,
    },
    { field: "service_name", headerName: "Service Name", width: 150 },
  ];

  const handleDownloadCSV = () => {
    const csvRows = [];
    const headers = [
      "Document ID",
      "Charge Type",
      "Country",
      "Rate",
      "Service Description",
      "Service Name",
    ];
    csvRows.push(headers.join(","));

    data?.forEach((invoice) => {
      const row = [
        invoice?.doc_id || "N/A",
        invoice?.charge_type || "N/A",
        invoice?.country || "N/A",
        invoice?.rate || "N/A",
        invoice?.service_description || "N/A",
        invoice?.service_name || "N/A",
      ].map((value) => `"\t${String(value).replace(/"/g, '""')}"`);
      csvRows.push(row.join(","));
    });

    const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `Amendment_Details_${invoiceNo}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: "90%",
            height: "73%",
            maxWidth: "1200px",
            borderRadius: 2,
            overflowY: "auto",
            zIndex: 99999,
          }}
        >
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <Typography
                id="modal-title"
                variant="h6"
                component="h2"
                sx={{ fontSize: "24px" }}
              >
                Amendment Details
              </Typography>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <button
                  onClick={handleDownloadCSV}
                  style={{
                    background: "#4CAF50",
                    color: "#fff",
                    padding: "10px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Download CSV
                </button>
                <IoClose
                  size={24}
                  onClick={() => {
                    setOpen(false);
                  }}
                />
              </div>
            </div>
            <DataTable columns={columns} rows={data} />
            {/* <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "20px",
              }}
            >
              <Button
                onClick={handleClose}
                style={{
                  flex: 1,
                  fontSize: "18px",
                  background: "#7C2EA0",
                  color: "white",
                  padding: "12px",
                }}
              >
                Close
              </Button>
            </div> */}
          </>
        </Box>
      </Modal>
    </div>
  );
};

export default AmendmentDetail;
